import styles from './RefineBar.less';

import { map, includes } from 'lodash';

import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { get, filter } from 'lodash';

import {
  updateActiveRefinement,
  clearActiveRefinement,
  selectRefinement
} from 'src/store/search/search';

import {
  ChevronIcon,
  ScreenReaderOnly,
  PageBlock
} from 'seek-style-guide/react';
import DateListed from './DateListed/DateListed';
import Salary from './Salary/Salary';
import WorkTypes from './WorkTypes/WorkTypes';
import WorkTypeSummary from './WorkTypeSummary/WorkTypeSummary';

import { getViewportWidth } from 'src/modules/responsive-helpers';

function mapStateToProps({ search }) {
  return {
    refinements: search.refinements,
    activeRefinement: search.activeRefinement
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateActiveFilter: refinement =>
      dispatch(updateActiveRefinement(refinement)),
    selectRefinement: type => dispatch(selectRefinement(type)),
    closeRefinements: () => dispatch(clearActiveRefinement())
  };
}

class RefineBar extends Component {
  static propTypes = {
    refinements: PropTypes.shape({
      worktype: PropTypes.array.isRequired,
      salary: PropTypes.object.isRequired
    }).isRequired,
    activeRefinement: PropTypes.string,
    updateActiveFilter: PropTypes.func.isRequired,
    selectRefinement: PropTypes.func.isRequired,
    closeRefinements: PropTypes.func.isRequired,
    expanded: PropTypes.bool.isRequired
  };

  storeCloseRefinementsReference = input => {
    if (input !== null) {
      this.closeRefinements = input;
    }
  };

  handleSelection = type => () => {
    if (type !== 'WorkType' && getViewportWidth() < 650) {
      this.closeRefinements.click();
    }

    this.props.selectRefinement(type);
  };

  onFilterChange = filterId => () => this.props.updateActiveFilter(filterId);

  render() {
    const {
      refinements,
      activeRefinement,
      closeRefinements,
      expanded
    } = this.props;

    const defaultSalaryTypeLabel = 'Annually';
    const selectedSalaryType = filter(
      get(refinements, 'salary.types', {}),
      'isActive'
    )[0] || {
      label: defaultSalaryTypeLabel
    };
    const selectedSalaryFrom = filter(
      get(refinements, 'salary.from', {}),
      'isActive'
    )[0] || {
      label: '$0'
    };
    const selectedSalaryTo = filter(
      get(refinements, 'salary.to', {}),
      'isActive'
    )[0] || {
      label:
        selectedSalaryType.label === defaultSalaryTypeLabel ? '$200k+' : '$100+'
    };
    const selectedDateListed = filter(
      get(refinements, 'dateRange', {}),
      'isActive'
    )[0] || {
      label: 'Any time',
      value: '999'
    };
    const refineDateListedLabel =
      selectedDateListed.value === '999' || selectedDateListed.value === '1'
        ? 'listed'
        : 'listed in';
    const fields = [
      {
        id: 'WorkType',
        ariaLabel: 'work type',
        label: <WorkTypeSummary workTypes={get(refinements, 'worktype')} />,
        handleSelection: this.handleSelection('WorkType'),
        filterComponent: WorkTypes,
        filterComponentProps: {
          workTypes: get(refinements, 'worktype')
        },
        styles: {
          toggle: styles.toggle_isWorkType,
          refinementPanel: styles.refinementPanel_isWorkType,
          summaryLabel: styles.summaryLabel_isWorkType
        }
      },
      {
        id: 'SalaryFrom',
        ariaLabel: 'minimum salary',
        summarySentence: 'paying ',
        label: selectedSalaryFrom.label,
        handleSelection: this.handleSelection('SalaryFrom'),
        filterComponent: Salary,
        filterComponentProps: {
          salaries: get(refinements, 'salary.from'),
          salaryTypes: get(refinements, 'salary.types'),
          label: 'Minimum'
        },
        styles: {
          toggle: styles.toggle_isSalaryFrom,
          refinementPanel: styles.refinementPanel_isSalaryFrom,
          summaryLabel: styles.summaryLabel_isSalaryFrom
        }
      },
      {
        id: 'SalaryTo',
        ariaLabel: 'maximum salary',
        summarySentence: 'to ',
        label: selectedSalaryTo.label,
        handleSelection: this.handleSelection('SalaryTo'),
        filterComponent: Salary,
        filterComponentProps: {
          salaries: get(refinements, 'salary.to'),
          salaryTypes: get(refinements, 'salary.types'),
          label: 'Maximum'
        },
        styles: {
          toggle: styles.toggle_isSalaryTo,
          refinementPanel: styles.refinementPanel_isSalaryTo,
          summaryLabel: styles.summaryLabel_isSalaryTo
        }
      },
      {
        id: 'DateListed',
        summarySentence: refineDateListedLabel,
        ariaLabel: 'date listed',
        label: selectedDateListed.label.toLowerCase(),
        handleSelection: this.handleSelection('DateListed'),
        filterComponent: DateListed,
        filterComponentProps: {
          dateRanges: get(refinements, 'dateRange')
        },
        styles: {
          toggle: styles.toggle_isDateListed,
          refinementPanel: styles.refinementPanel_isDateListed,
          summaryLabel: styles.summaryLabel_isDateListed
        }
      }
    ];

    const rootClasses = classnames({
      [styles.root]: true,
      [styles.root_isExpanded]: expanded,
      [styles.root_isRefining]: includes(map(fields, 'id'), activeRefinement)
    });

    return (
      <aside
        role="navigation"
        aria-hidden={!expanded}
        aria-labelledby="refine-your-search"
        className={rootClasses}
      >
        <ScreenReaderOnly>
          <h1 id="refine-your-search">Refine your search</h1>
        </ScreenReaderOnly>

        {map(fields, field => (
          <input
            id={`RefineBar--${field.id}`}
            key={field.id}
            className={classnames(styles.toggle, field.styles.toggle)}
            name="RefineBar__Toggle"
            type="radio"
            role="button"
            aria-expanded={expanded}
            aria-label={`refine by ${fields.ariaLabel}`}
            checked={activeRefinement === field.id}
            onChange={this.onFilterChange(field.id)}
          />
        ))}

        <input
          id="RefineBar--Done"
          className={styles.done}
          type="radio"
          name="RefineBar__Toggle"
          onChange={closeRefinements}
          ref={this.storeCloseRefinementsReference}
        />

        <label
          className={`${styles.summaryLabel} ${styles.summaryLabel_isDone}`}
          htmlFor="RefineBar--Done"
          onChange={closeRefinements}
        >
          <ScreenReaderOnly>Hide refinements</ScreenReaderOnly>
        </label>

        <PageBlock className={styles.summary}>
          <div className={styles.summaryInner}>
            {map(fields, (field, index) => (
              <label
                key={field.id}
                className={classnames(
                  styles.summaryLabel,
                  field.styles.summaryLabel
                )}
                htmlFor={`RefineBar--${field.id}`}
                onClick={this.onFilterChange(field.id)}
                data-automation={`toggle${field.id}Panel`}
              >
                <ScreenReaderOnly>{`Show ${
                  field.ariaLabel
                } refinements. `}</ScreenReaderOnly>
                <span className={styles.summaryLabelText}>
                  {field.summarySentence && (
                    <span className={styles.summarySentence} aria-hidden="true">
                      {field.summarySentence}
                    </span>
                  )}
                  {field.label}
                  <ChevronIcon
                    direction="down"
                    svgClassName={styles.chevronSvg}
                  />
                </span>
                {!index && (
                  <span
                    className={`${styles.summaryLabelBorder} ${
                      styles.summaryLabelBorder_isLeft
                    }`}
                  />
                )}
                <span
                  className={`${styles.summaryLabelBorder} ${
                    styles.summaryLabelBorder_isRight
                  }`}
                />
              </label>
            ))}

            <label
              className={styles.summaryDone}
              htmlFor="RefineBar--Done"
              onClick={closeRefinements}
            >
              <ScreenReaderOnly>Hide refinements</ScreenReaderOnly>
            </label>
          </div>
        </PageBlock>

        {map(fields, field => {
          const FilterComponent = field.filterComponent;

          return (
            <PageBlock
              key={field.id}
              className={classnames(
                styles.refinementPanel,
                field.styles.refinementPanel
              )}
            >
              <FilterComponent
                active={activeRefinement === field.id}
                handleSelection={field.handleSelection}
                {...field.filterComponentProps}
              />
            </PageBlock>
          );
        })}

        <div className={styles.backdrop} />
      </aside>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RefineBar);
